<template>
    <AppLayout>
        <div class="container p-4 mx-auto md:px-1 md:py-4">
            <!-- breadcrumb -->
            <Breadcrumb
                :title="$tc('LBL_COMPLAIN')"
                :items="[{ label: $tc('LBL_COMPLAIN', 2) }]"
                :home-label="$t('LBL_HOME')"
                :home-url="route('landing')"
            />
            <!-- breadcrumb end -->

            <div
                class="w-full bg-white dark:bg-gray-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 overflow-overflow"
            >
                <div
                    class="w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-none shadow-md"
                >
                    <div class="overflow-x-auto">
                        <table
                            class="min-w-[700px] w-full table-auto text-sm sm:text-base text-left text-gray-700 dark:text-gray-300"
                        >
                            <thead class="bg-gray-100 dark:bg-gray-700 text-sm font-semibold">
                                <tr>
                                    <!-- <th class="px-4 py-3">#</th> -->
                                    <th class="px-4 py-3">COMPLAIN BY</th>
                                    <th class="px-4 py-3">DETAILS</th>
                                    <th class="px-4 py-3">SUBMITTED AT BALANCE</th>
                                    <th class="px-4 py-3">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(row, rowIndex) in complains">
                                    <tr
                                        :class="[
                                            'border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition duration-200',
                                        ]"
                                    >
                                        <td class="px-4 py-3">
                                            <!-- eslint-disable-next-line vue/no-v-html -->
                                            <div v-html="row.user.name" />
                                        </td>
                                        <td class="px-4 py-3">
                                            <!-- eslint-disable-next-line vue/no-v-html -->
                                            <div v-html="row.details" />
                                        </td>

                                        <td class="px-4 py-3">
                                            {{ row.created_at | fromNow }}
                                        </td>

                                        <td class="px-4 py-3">
                                            <Button
                                                text="View"
                                                color="green"
                                                @onClick="viewComplain(row)"
                                            />
                                        </td>
                                    </tr>
                                </template>
                                <tr
                                    v-if="!complains.length"
                                    class="text-center"
                                >
                                    <td
                                        colspan="6"
                                        class="px-4 py-4 text-gray-500 dark:text-gray-400"
                                    >
                                        {{ $t('LBL_DATA_FOUND') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from '../../Layouts/AppLayout.vue';
    import Button from '../../Components/Button.vue';
    import Breadcrumb from '@/Components/Breadcrumb.vue';

    export default {
        name: 'ComplainIndex',

        components: {
            AppLayout,
            Button,
            Breadcrumb,
        },

        props: {
            complains: {
                type: Array,
                required: true,
            },
        },

        methods: {
            viewComplain(complain) {
                this.$inertia.get(route('complains.show', { complainId: complain.id }));
            },
        },
    };
</script>
